(() => {
  function initCustomMegaMenu(root = document) {
    const detailsItems = root.querySelectorAll('.custom-mega__details');

    detailsItems.forEach((details) => {
      if (details.dataset.customMegaReady === 'true') return;
      details.dataset.customMegaReady = 'true';

      const summary = details.querySelector('summary');
      let closeTimer;

      const openMenu = () => {
        window.clearTimeout(closeTimer);

        detailsItems.forEach((item) => {
          if (item !== details) {
            item.removeAttribute('open');
            item.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          }
        });

        details.setAttribute('open', '');
        summary?.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        closeTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) {
            details.removeAttribute('open');
            summary?.setAttribute('aria-expanded', 'false');
          }
        }, 140);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);
      details.addEventListener('focusin', openMenu);
      details.addEventListener('focusout', closeMenu);

      details.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        details.removeAttribute('open');
        summary?.setAttribute('aria-expanded', 'false');
        summary?.focus();
      });

      summary?.addEventListener('click', () => {
        window.setTimeout(() => {
          summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
        });
      });
    });

    document.addEventListener(
      'pointerdown',
      (event) => {
        if (event.target.closest('.custom-mega__details')) return;

        document.querySelectorAll('.custom-mega__details[open]').forEach((details) => {
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCustomMegaMenu());
  } else {
    initCustomMegaMenu();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCustomMegaMenu(event.target);
  });
})();
